import React, { useEffect } from "react";
import AppRoutes from "./data/app-routes";
import { LanguageProvider } from "./context/language-context";
import { Provider } from "react-redux";
import store from "./state/store";
import { AppProvider, UserProvider } from "./context";
import { Loader, LoaderState } from "./context/loader";


const App: React.FC = () => {
  return (
    <>
      <LanguageProvider>
        <Provider store={store}>
          <AppProvider>
            <UserProvider>
              <LoaderState>
                <Loader />
                <AppRoutes></AppRoutes>
              </LoaderState>
            </UserProvider>
          </AppProvider>
        </Provider>
      </LanguageProvider>
    </>
  );
};

export default App;
